import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

import GiftsStore from 'stores/GiftsStore';
import Modal from 'components/Modal/Modal';

import SendUserGift from './SendUserGift';


function SendUserGiftModal({ show, close, gift, handleBackClick }) {
  const handleClose = useCallback(() => {
    close();
    handleBackClick?.();
  }, [close, handleBackClick]);

  useEffect(() => {
    GiftsStore.resetSendGiftStatus();
  }, []);

  return (
    <Modal
      background="transparent"
      close={handleClose}
      show={show}
      showClose={false}
      size="medium"
    >
      <SendUserGift
        close={handleClose}
        gift={gift}
        isDesktop={true}
      />
    </Modal>
  );
}

SendUserGiftModal.propTypes = {
  close: PropTypes.func.isRequired,
  gift: PropTypes.object.isRequired,
  handleBackClick: PropTypes.func,
  show: PropTypes.bool,
};

SendUserGiftModal.defaultProps = {
  handleBackClick: () => undefined,
  show: false,
};

export default SendUserGiftModal;
